import * as React from "react"
import { Tooltip, TooltipContent, TooltipTrigger } from "./tooltip"

type TipSide = "top" | "right" | "bottom" | "left"

/**
 * Tip — tooltip estándar del sistema (shadcn/Radix).
 *
 * Reemplaza al atributo nativo `title="..."` (que produce el tooltip gris del
 * navegador, inconsistente con el diseño). Uso como wrapper de UN solo elemento:
 *
 *   <Tip label="Eliminar">
 *     <button onClick={...}><TrashIcon /></button>
 *   </Tip>
 *
 * El hijo debe ser un único elemento que acepte ref (cualquier tag HTML nativo
 * o componente con forwardRef). Si `label` es vacío/null, renderiza el hijo tal cual.
 */
export function Tip({
  label,
  children,
  side,
  className,
}: {
  label?: React.ReactNode
  children: React.ReactElement
  side?: TipSide
  className?: string
}) {
  if (label === undefined || label === null || label === "") return children
  return (
    <Tooltip>
      <TooltipTrigger asChild>{children}</TooltipTrigger>
      <TooltipContent side={side} className={className}>
        {label}
      </TooltipContent>
    </Tooltip>
  )
}

export default Tip
